import each from 'lodash/each';

import logger from '../../utils/logger';

class Custom {
  _append(url, type) {
    let el = document.createElement('iframe');

    el.src = url;
    el.scrolling = 'no';
    el.frameborder = '0';
    el.height = '0';
    el.width = '0';
    el.style = 'display:block';

    document.querySelector('.vs-thank-you').appendChild(el);

    logger.log(`${type} iframe added`);
  }

  clientViewThankYou({ state }) {
    logger.groupCollapsed('Client Custom');

    each(state.order.orders, order => {
      logger.groupCollapsed(order.campaign_name);

      let urlGlobal = state.order.tracking[order.analytics_cid].global.custom,
        urlCampaign = state.order.tracking[order.analytics_cid].campaign.custom;

      if (logger.checkCampaign(urlCampaign)) {
        this._append(urlCampaign, 'Campaign specific');
      }

      if (logger.checkGlobal(urlGlobal, urlCampaign)) {
        this._append(urlGlobal, 'Global');
      }

      logger.groupEnd();
    });

    logger.groupEnd();
  }
};

export default new Custom();